import { useState } from "react";
import { Star } from "lucide-react";
import { api } from "../api/api";
import Swal from "sweetalert2";

const Ratings = ({ totalStars = 5, ratingType, rating, setRating, vehicle, setShowToast, isLoggedIn }) => {
  const [hover, setHover] = useState(0);

  const handleClick = (index) => {
    // Ratings require login (enforced again on the server via the session cookie).
    if (!isLoggedIn) {
      Swal.fire({
        icon: 'info',
        title: 'You must be logged in!',
        text: 'Please login to rate this vehicle.',
        confirmButtonColor: '#6f48e5',
      });
      return;
    }

    // Server validates: booking requirement (Customer) and one vote per user.
    api.post("/vehicles/updaterating", {
      vehicleId: vehicle._id,
      ratingType,
      rating: index,
    }, { withCredentials: true })
      .then(() => {
        setRating(index);
        setShowToast(true);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'info',
          title: 'Could not save rating',
          text: error.response?.data?.message || 'Something went wrong. Please try again.',
          confirmButtonColor: '#6f48e5',
        });
      });
  };

  return (
    <div className="flex flex-col items-center">
      <div className="flex flex-row space-x-1">
        {[...Array(totalStars)].map((_, index) => {
          const starValue = index + 1;
          return (
            <Star
              key={index}
              className={`w-4 h-4 cursor-pointer transition-all duration-300 ${
                starValue <= (hover || rating) ? "text-[#6F48E5]" : "text-[#A9B9E3]"
              }`}
              onClick={() => handleClick(starValue)}
              onMouseEnter={() => setHover(starValue)}
              onMouseLeave={() => setHover(0)}
              fill={starValue <= (hover || rating) ? "currentColor" : "none"}
              strokeWidth={1.5}
            />
          );
        })}
      </div>
      <div className="text-gray-500">Rate as {ratingType}</div>
    </div>
  );
};

export default Ratings;